import { ReactElement, useEffect, useState } from "react"
import { FranchiseModel } from "../../../data/entity/franchise-model"
import { makeSendContact } from "../../../main/helper/factories/send-contact-factory"
import { FranchiseContext } from "../../context/franchise-context/franchise-context"
import { FooterAddress } from "../footer/footer-address"
import { FooterSimple } from "../footer/footer-simple"
import { FranchiseError } from "../franchise/franchise-error"
import { FranchiseNoContent } from "../franchise/franchise-no-content"
import { Header } from "../header/header"
import { Loading } from "../loading/loading"
import { AboutMore } from "../sections/about-more/about"
import { About } from "../sections/about/about"
import { Banner } from "../sections/banner/banner"
import { Clinic } from "../sections/clinic/clinic"
import { Contact } from "../sections/contact/contact"
import { Faq } from "../sections/faq/faq"
import { Hero } from "../sections/hero/hero"
import { Partner } from "../sections/partner/partner"
import { PlainText } from "../sections/plain-text/plain-text"
import { Price } from "../sections/price/price"
import { Testimonials } from "../sections/testimonials/testimonials"
import { WhatsAppLinkButton } from "../whatsapp-link-button/whatsapp-link-button"
import { HomeProps } from "./home-props"
import * as S from './home-styles'

export enum PageState {
  LOADING,
  READY,
  NO_CONTENT,
  ERROR
}

export enum LandingpageType {
  PHYSICAL = 'PHYSICAL',
  DIGITAL = 'DIGITAL'
}

const sendContact = makeSendContact()

export function Home ({ loadFranchise, apiUrl }: HomeProps): ReactElement {
  const [state, setState] = useState<PageState>(PageState.LOADING)
  const [data, setData] = useState<FranchiseModel>({} as unknown as FranchiseModel)

  useEffect(() => {
    (async () => {
      setState(PageState.LOADING)
      const response = await loadFranchise.handle()
      switch (response.status) {
        case 200:
          setData(response.data)
          setState(PageState.READY)
          break
        case 204:
          setState(PageState.NO_CONTENT)
          break
        default:
          setState(PageState.ERROR)
      }
    })()
  }, [loadFranchise])

  if (state === PageState.LOADING) return <Loading />
  if (state === PageState.NO_CONTENT) return <FranchiseNoContent />
  if (state === PageState.ERROR) return <FranchiseError />
  return <FranchiseContext.Provider value={data}>
    <Header />
    <S.Container>{data.sections.map(section => {
      switch (section.type) {
        case 'HERO': return <Hero {...section} />
        case 'BANNER': return <Banner {...section} />
        case 'PRICE': return <Price {...section} />
        case 'ABOUT_CARTAO_DE_TODOS': return <About {...section} mainLink={data.mainLink} apiUrl={apiUrl} />
        case 'ABOUT_CARTAO_DE_TODOS_MORE': return <AboutMore {...section} />
        case 'PARTNER': return <Partner {...section} />
        case 'CLINICS': return <Clinic {...section} mainLink={data.mainLink} apiUrl={apiUrl} />
        case 'PLAIN_TEXT': return <PlainText {...section} />
        case 'TESTIMONIALS': return <Testimonials {...section} />
        case 'CONTACT': return <Contact sendContact={sendContact} {...section} />
        case 'FAQ': return <Faq {...section} />
        default: <>{section.type}</>
      }
      return <></>
    })}</S.Container>
    <WhatsAppLinkButton phone={data.footer.whatsapp} />
    {data.type === LandingpageType.PHYSICAL && <FooterAddress {...data.footer} />}
    {data.type === LandingpageType.DIGITAL && <FooterSimple {...data.footer} />}
  </FranchiseContext.Provider>
}